// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Njtw","content":"RecentSearches_content__3jU_l"};